import { LoadingIndicator } from '@thoughtspot/radiant-react/widgets/loading-indicator';
import React, { Suspense } from 'react';
import { NotificationsContainer } from '../../microfrontends/coms';

export const NotificationContainer: React.FC = () => {
    return (
        <Suspense fallback={<LoadingIndicator />}>
            <NotificationsContainer />
        </Suspense>
    );
};
